module.exports = __webpack_public_path__ + "static/media/munch1.de053922.wav";